

import { useQuery } from 'react-query';
import Cookies from "js-cookie";
export const useAllFlashes = () => {
  const users = Cookies.get('token')






  const fetchFlashes = async () => {

   

  const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/flash`,
      {
        method: "GET",
        headers: {

          'Authorization': `Bearer ${users}`
        },
      
      });
   
    const json = await response.json()
    if (response.ok) {
      return json;
  
    }
  }



  

  // return { fetchFlashes }

const {data:allFlashes} = useQuery(
  "flash",
  fetchFlashes,
{
  cacheTime:1.2e+6
}
  
)


const customFlash = async() => {

  const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/flash/custom-flash`,
    {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${users}`
      }
    });
 
  const json = await response.json()

  if (response.ok) {
    return json;
  } 
}


const {data:customFlashData} = useQuery(
  "customFlash",
  customFlash,
{
  cacheTime:1.2e+6,

}

)

  return { allFlashes,customFlashData }



}

